import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Box, CssBaseline, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { Navbar } from "../navbar";
import { Sidebar } from "../sidebar";
import { dashboardSummaryV2 } from "../../services/dashboardService";

const DRAWER_WIDTH = 280;
const DRAWER_COLLAPSED_WIDTH = 90;

const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  backgroundColor: "#f8fafc",
  minHeight: "100vh",
  width: "100%",
  overflow: "hidden",
  transition: theme.transitions.create(['margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
  },
  [theme.breakpoints.down("sm")]: {
    padding: 0,
  },
}));

export const Layout = () => {
  const [open, setOpen] = useState(true);
  const [dashboardSummary, setDashboardSummary] = useState(null);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchDashboardSummary = async () => {
      if (!user?.jwt) return;
      try {
        const res = await dashboardSummaryV2(user.jwt);
        if (res?.status === 200) {
          setDashboardSummary(res.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard summary:", error);
      }
    };
    fetchDashboardSummary();
  }, [user?.jwt]);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />
      <Navbar open={open} setOpen={setOpen} dashboardSummary={dashboardSummary} />
      <Sidebar open={open} setOpen={setOpen} dashboardSummary={dashboardSummary} />
      <Main open={open}>
        <Box sx={{ width: "100%", maxWidth: "100%", overflow: "auto" }}>
          <Outlet context={{ dashboardSummary }} />
        </Box>
      </Main>
    </Box>
  );
};
